import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingImage from '../../assets/images/loader.svg';
import dataModel from '../../models/DataModel';
import LoadingDots from '../../components/LoadingDots';

import './WaitSpinner.scss';
export class WaitSpinner extends Component {

  constructor(props){
    super(props);

    this.handleExpireyTimeout = this.handleExpireyTimeout.bind(this);
    this.handleWaitTimeout = this.handleWaitTimeout.bind(this);
  }

  componentWillUnmount() {
    if (this.expireyTimer) {
      clearTimeout(this.expireyTimer);
    }
    if (this.waitTimer) {
      clearTimeout(this.waitTimer);
    }
  }

  // displayHTTPError renders `action + ': ' + message`. this.message was never assigned on
  // this component and no call site passes one, so every timeout read "undefined: ...".
  get actionLabel() {
    return this.props.message || 'Loading';
  }

  handleExpireyTimeout() {
    this.expired = true;
    this.props.dataModel.displayHTTPError(this.actionLabel, 'A timeout occurred while loading data.', false);
  }

  handleWaitTimeout() {
    this.waiting = true;
    this.props.dataModel.displayHTTPError(this.actionLabel, 'The action is taking a long time to complete.', false);
  }

  render() {
    if (this.expireyTimer) {
      clearTimeout(this.expireyTimer);
    }
    if (this.waitTimer) {
      clearTimeout(this.waitTimer);
    }

    if (!this.waiting) {
      this.waitTimer = setTimeout(this.handleWaitTimeout, 30000);
    }
    let spinner = <img className="loader" src={LoadingImage} alt="loading-icon" />;

    if (!this.props.userSpinner) {
      spinner = <LoadingDots/>;
    }

    return (

      <div className="wait-spinner" >
        <section className="top-section" >
          {spinner}
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    catastrophicError: state.main.catastrophicError,
    dataModel: dataModel,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WaitSpinner);



// WEBPACK FOOTER //
// ./src/components/WaitSpinner/index.js